import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";
import MenuPrinc from "../../Componentes/MenuPrinc";

import carregando from "../../Images/carregando.gif";
import Certo from "../../Images/icon-check.png";
import HeaderPortalVendedor from "../HeaderPortalVendedor";

import { URLBunge } from "../../Componentes/Config";

import { Container, HomeFornada } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBContainer,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBAlert,
} from "mdbreact";

import readXlsxFile from "read-excel-file";

// import { GetApi, PostApi } from "../../services/auth";

import { MudaVisibilidade } from "../../services/funcoes";
import Axios from "axios";
import InputMask from "react-input-mask";

import Carregando from "../../Componentes/Carregando";
import axios from "axios";

let arquivo = [];
let ImgReal = [];
var dataTable = {
  columns: [
    {
      label: "Nome",
      field: "nome",
      sort: "asc",
      width: 100,
    },
    {
      label: "Login",
      field: "login",
      sort: "asc",
      width: 100,
    },
    {
      label: "CPF",
      field: "codExt",
      sort: "asc",
      width: 100,
    },
    {
      label: "Departamento",
      field: "departamento",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Editar",
      field: "editar",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

function VendedorUsers() {
  const TOKEN = localStorage.getItem("c_token");
  const EMAIL_USUARIO = localStorage.getItem("c_email");
  const history = useHistory();

  const [loading, setLoading] = useState(true);

  const [vendedores, setVendedores] = useState({});
  const [ImgReal, setImgReal] = useState([]);
  const [cargo, setCargo] = useState("");
  const [nameselect, setNameselect] = useState("o cargo ao lado");
  const [activeItem, setActiveItem] = useState("1");
  const [gerentesTotal, setGerentesTotal] = useState([]);
  const [supervisoresTotal, setSupervisoresTotal] = useState([]);
  const [vendedoresTotal, setVendedoresTotal] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [lojascomvinculo, setLojascomvinculo] = useState([]);
  const [lojassemvinculo, setLojassemvinculo] = useState([]);
  const [userSelect, setUserSelect] = useState({
    id: 0,
    nome: "",
    codExt: "",
    login: "",
    departamento: 8,
    status: 1,
    lojas: [],
    usuariosFilhos: [],
    usuariosPais: [],
    gerentescomvinculo: [],
    gerentessemvinculo: [],
    supervisorescomvinculo: [],
    supervisoressemvinculo: [],
    vendedorescomvinculo: [],
    vendedoressemvinculo: [],
    endereco: {},
    cep: "",
  });
  const [pesquisaLoja, setPesquisaLoja] = useState("");
  const [pesquisaVendedor, setPesquisaVendedor] = useState("");
  const [pesquisaSupervisor, setPesquisaSupervisor] = useState("");
  const [pesquisaGerente, setPesquisaGerente] = useState("");
  const [dadosUparGerentes, setDadosUparGerentes] = useState([]);
  const [dadosUparSupervisores, setDadosUparSupervisores] = useState([]);
  const [dadosUparVendedores, setDadosUparVendedores] = useState([]);
  const [CarregarGer, setCarregarGer] = useState(true);
  const [CarregarSup, setCarregarSup] = useState(true);
  const [CarregarVend, setCarregarVend] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [block, setBlock] = useState("readOnly");
  const [modal4, setModal4] = useState(false);
  const [modal5, setModal5] = useState(false);

  useEffect(() => {
    BuscaVendedores();

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Vendedores/ListaLojas`, requestOptions)
      .then((response) => response.json())
      .then((retornoLojas) => {
        setLoading(false);

        setLojas(retornoLojas.lista);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  async function BuscaVendedores() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const retornoVendedores = await fetch(
      `${URLBunge}/api/Vendedores/ListaVendedores`,
      requestOptions
    ).then((response) => response.json());

    var logs = dataTable;
    logs.rows = [];

    if (retornoVendedores.sucesso) {
      setVendedores({});
      // setState({ vendedores:{}});

      var gerentesTotalArray = [];
      var supervisoresTotalArray = [];
      var vendedoresTotalArray = [];

      await retornoVendedores.usuarios.forEach(async (log) => {
        if (log.departamentoId == 8) {
          gerentesTotalArray.push(log);
        } else if (log.departamentoId == 9) {
          supervisoresTotalArray.push(log);
        } else if (log.departamentoId == 10) {
          vendedoresTotalArray.push(log);
        }
        logs.rows.push({
          nome: log.nome,
          login: log.login,
          codExt: log.codExt,
          departamento: log.departamento,
          status:
            log.status == 1 ? (
              <MDBBtn
                color="red"
                size="sm"
                onClick={() => AlteraStatus(log.id, 2)}
              >
                Bloquear
              </MDBBtn>
            ) : (
              <MDBBtn
                color="green"
                size="sm"
                onClick={() => AlteraStatus(log.id, 1)}
              >
                Desbloquear
              </MDBBtn>
            ),
          editar: (
            <MDBBtn color="blue" size="sm" onClick={() => Editar(log)}>
              Editar
            </MDBBtn>
          ),
        });
      });

      setVendedores(logs);
      setGerentesTotal(gerentesTotalArray);
      setSupervisoresTotal(supervisoresTotalArray);
      setVendedoresTotal(vendedoresTotalArray);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: retornoVendedores.mensagem,
      });
    }
  }

  async function AlteraStatus(idUser, status) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const retorno = await fetch(
      `${URLBunge}/api/Vendedores/AlteraStatus/${idUser}/${status}`,
      requestOptions
    ).then((response) => response.json());

    if (retorno.sucesso) {
      var msg =
        status == 1
          ? "Usuário Desbloqueado com Sucesso"
          : "Usuário Bloqueado com Sucesso";
      Swal.fire({
        icon: "success",
        title: "Tudo Certo!",
        text: msg,
      });
      BuscaVendedores();
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: retorno.mensagem,
      });
    }
  }

  async function arquivoexemplo() {
    window.location.href =
      "http://www.plataformaomnion.com.br/banner/fornada/cadastro.xlsx";
  }

  async function NovoUser() {
    setDisabled(false);
    setBlock("");

    var lojassemvinculoArray = lojas;

    setLojascomvinculo([]);
    setLojassemvinculo([...lojassemvinculoArray]);
    setUserSelect({
      id: 0,
      nome: "",
      codExt: "",
      login: "",
      departamento: 8,
      statusId: 1,
      lojas: [],
      usuariosFilhos: [],
      usuariosPais: [],
      gerentescomvinculo: [],
      gerentessemvinculo: gerentesTotal,
      supervisorescomvinculo: [],
      supervisoressemvinculo: supervisoresTotal,
      vendedorescomvinculo: [],
      vendedoressemvinculo: vendedoresTotal,
      endereco: {},
    });

    toggle(4);
  }

  async function Editar(log) {
    setDisabled(true);

    if (log.codExt === "") {
      setBlock("readOnly");
    } else {
      setBlock("");
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    setLoading(true);

    const retornoUser = await fetch(
      `${URLBunge}/api/Vendedores/BuscaVendedor/${log.id}`,
      requestOptions
    )
      .then((response) => response.json())
      .catch((erro) => {
        setLoading(false);
        console.log("Error", erro);
      });

    setLoading(false);

    setLojas(retornoUser.lojas);

    retornoUser.gerentescomvinculo = [];
    retornoUser.gerentessemvinculo = [];
    retornoUser.supervisorescomvinculo = [];
    retornoUser.supervisoressemvinculo = [];
    retornoUser.vendedorescomvinculo = [];
    retornoUser.vendedoressemvinculo = [];

    retornoUser.gerentesV = false;
    retornoUser.supervisoresV = false;
    retornoUser.vendedoresV = false;
    retornoUser.endereco =
      retornoUser.endereco != null ? retornoUser.endereco : {};

    var lojascomvinculoArray = [];
    var lojassemvinculoArray = [];

    lojas.map((loj) => {
      if (retornoUser.lojas.find((loja) => loja == loj.id)) {
        lojascomvinculoArray.push(loj);
      } else {
        lojassemvinculo.push(loj);
      }
    });

    setUserSelect(retornoUser);
    setLojascomvinculo([...lojascomvinculoArray]);
    setLojassemvinculo([...lojassemvinculoArray]);

    // alteraAbas(retornoUser.departamento);
    toggle(4);
  }

  function toggletab(tab) {
    if (activeItem !== tab) {
      setActiveItem(tab);
    }
  }

  function toggle(nr) {
    if (nr === 4) {
      setModal4((oldValue) => !oldValue);
    } else {
      setModal5((oldValue) => !oldValue);
    }
  }

  async function CadastrarExcel() {
    MudaVisibilidade("GerenteUp");
    const a = dadosUparGerentes.map(async (ger) => {
      const newDado = {
        id: 0,
        nome: "",
        codExt: "",
        login: "",
        departamento: 8,
        statusId: 1,
        lojas: [],
        usuariosFilhos: [],
        usuariosPais: [],
        gerentescomvinculo: [],
        gerentessemvinculo: [],
        supervisorescomvinculo: [],
        supervisoressemvinculo: [],
        vendedorescomvinculo: [],
        vendedoressemvinculo: [],

        endereco: {},
      };
      newDado.nome = ger.nome;
      newDado.login = ger.login;
      newDado.departamento = 8;
      newDado.statusId = 1;
      var lojasComVinculo = ger.lojas;
      await AttUserExcel(newDado, lojasComVinculo);
    });

    await Promise.all(a);
    await BuscaVendedores();

    setCarregarGer(false);

    MudaVisibilidade("SupervisorUp");
    const b = dadosUparSupervisores.map(async (sup, i) => {
      const newDado = {
        id: 0,
        nome: "",
        codExt: "",
        login: "",
        departamento: 8,
        statusId: 1,
        lojas: [],
        usuariosFilhos: [],
        usuariosPais: [],
        gerentescomvinculo: [],
        gerentessemvinculo: [],
        supervisorescomvinculo: [],
        supervisoressemvinculo: [],
        vendedorescomvinculo: [],
        vendedoressemvinculo: [],

        endereco: {},
      };
      newDado.nome = sup.nome;
      newDado.login = sup.login;
      newDado.departamento = 9;
      newDado.statusId = 1;
      await sup.emailPai.map((e) => {
        newDado.gerentescomvinculo.push(
          gerentesTotal.find((g) => g.login == e)
        );
      });
      var lojasComVinculo = sup.lojas;
      await AttUserExcel(newDado, lojasComVinculo);
    });
    await Promise.all(b);
    await BuscaVendedores();

    setCarregarSup(false);
    // setState({CarregarSup:false});

    MudaVisibilidade("VendedorUp");

    const c = dadosUparVendedores.map(async (vend, i) => {
      const newDado = {
        id: 0,
        nome: "",
        codExt: "",
        login: "",
        departamento: 8,
        statusId: 1,
        lojas: [],
        usuariosFilhos: [],
        usuariosPais: [],
        gerentescomvinculo: [],
        gerentessemvinculo: [],
        supervisorescomvinculo: [],
        supervisoressemvinculo: [],
        vendedorescomvinculo: [],
        vendedoressemvinculo: [],

        endereco: {},
      };
      newDado.nome = vend.nome;
      newDado.login = vend.login;
      newDado.departamento = 10;
      newDado.statusId = 1;
      vend.emailPai.map((e) => {
        newDado.supervisorescomvinculo.push(
          supervisoresTotal.find((g) => g.login == e)
        );
      });
      var lojasComVinculo = vend.lojas;
      await AttUserExcel(newDado, lojasComVinculo);
    });
    await Promise.all(c);

    // setState({CarregarVend:false});
    setCarregarVend(false);

    Swal.fire({
      icon: "success",
      title: "Tudo Certo!",
      text: "Cadastros Realizados com sucesso!",
    }).then(async (result) => {
      window.location = "/VendedorUsers";
    });
  }

  async function LeArquivo(e) {
    var dadosUparGerentes = [];
    var dadosUparSupervisores = [];
    var dadosUparVendedores = [];
    readXlsxFile(e.target.files[0]).then((rows) => {
      rows.map((r, j) => {
        if (j > 0) {
          if (!dadosUparGerentes.find((d) => d.login == r[4])) {
            dadosUparGerentes.push({
              nome: r[3],
              login: r[4],
              lojas: [],
            });
          }
          if (
            !dadosUparGerentes.find((d) => d.login == r[6]) &&
            !dadosUparSupervisores.find((d) => d.login == r[6])
          ) {
            dadosUparSupervisores.push({
              emailPai: [r[4]],
              nome: r[5],
              login: r[6],
              lojas: [],
            });
          } else {
            if (dadosUparSupervisores.find((d) => d.login == r[6])) {
              if (
                !dadosUparSupervisores
                  .find((d) => d.login == r[6])
                  .emailPai.find((d) => d == r[4])
              ) {
                dadosUparSupervisores
                  .find((d) => d.login == r[6])
                  .emailPai.push(r[4]);
              }
            }
          }
          if (
            !dadosUparGerentes.find((d) => d.login == r[8]) &&
            !dadosUparSupervisores.find((d) => d.login == r[8]) &&
            !dadosUparVendedores.find((d) => d.login == r[8])
          ) {
            dadosUparVendedores.push({
              emailPai: [r[6]],
              nome: r[7],
              login: r[8],
              lojas: [lojas.find((e) => e.cnpj == r[0])],
            });
          } else {
            if (dadosUparVendedores.find((d) => d.login == r[8])) {
              if (
                !dadosUparVendedores
                  .find((d) => d.login == r[8])
                  .emailPai.find((d) => d == r[6])
              ) {
                dadosUparVendedores
                  .find((d) => d.login == r[8])
                  .emailPai.push(r[6]);
              }

              lojas.find((e) => e.cnpj == r[0]) &&
                dadosUparVendedores
                  .find((d) => d.login == r[8])
                  .lojas.push(lojas.find((e) => e.cnpj == r[0]));
            } else if (dadosUparSupervisores.find((d) => d.login == r[8])) {
              lojas.find((e) => e.cnpj == r[0]) &&
                dadosUparSupervisores
                  .find((d) => d.login == r[8])
                  .lojas.push(lojas.find((e) => e.cnpj == r[0]));
            } else if (dadosUparGerentes.find((d) => d.login == r[8])) {
              lojas.find((e) => e.cnpj == r[0]) &&
                dadosUparGerentes
                  .find((d) => d.login == r[8])
                  .lojas.push(lojas.find((e) => e.cnpj == r[0]));
            }
          }
        }
      });

      setDadosUparGerentes(dadosUparGerentes);
      setDadosUparSupervisores(dadosUparSupervisores);
      setDadosUparVendedores(dadosUparVendedores);

      MudaVisibilidade("ArquivoInput");
      MudaVisibilidade("ArquivoCadastrar");
    });
  }

  async function alteraAbas(e) {
    var newDado = userSelect;

    if (e === "8") {
      newDado.gerentescomvinculo = [];
      newDado.gerentessemvinculo = [];
      gerentesTotal.map((ger) => {
        if (newDado.usuariosPais.find((user) => user == ger.id)) {
          newDado.gerentescomvinculo.push(ger);
        } else {
          newDado.gerentessemvinculo.push(ger);
        }
      });
      newDado.supervisorescomvinculo = [];
      newDado.supervisoressemvinculo = [];
      supervisoresTotal.map((ger) => {
        if (newDado.usuariosFilhos.find((user) => user == ger.id)) {
          newDado.supervisorescomvinculo.push(ger);
        } else {
          newDado.supervisoressemvinculo.push(ger);
        }
      });

      newDado.vendedorescomvinculo = [];
      newDado.vendedoressemvinculo = [];
      newDado.gerentesV = true;
      newDado.supervisoresV = true;
      newDado.vendedoresV = false;
    } else if (e === "9") {
      // console.log("***ABA_SUPERVISOR")
      newDado.gerentescomvinculo = [];
      newDado.gerentessemvinculo = [];
      gerentesTotal.map((ger) => {
        if (newDado.usuariosPais.find((user) => user == ger.id)) {
          newDado.gerentescomvinculo.push(ger);
        } else {
          newDado.gerentessemvinculo.push(ger);
        }
      });

      newDado.supervisorescomvinculo = [];
      newDado.supervisoressemvinculo = [];

      newDado.vendedorescomvinculo = [];
      newDado.vendedoressemvinculo = [];
      vendedoresTotal.map((ger) => {
        if (newDado.usuariosFilhos.find((user) => user == ger.id)) {
          newDado.vendedorescomvinculo.push(ger);
        } else {
          newDado.vendedoressemvinculo.push(ger);
        }
      });

      newDado.gerentesV = true;
      newDado.supervisoresV = false;
      newDado.vendedoresV = true;
    } else if (e === "10") {
      newDado.gerentescomvinculo = [];
      newDado.gerentessemvinculo = [];

      newDado.supervisorescomvinculo = [];
      newDado.supervisoressemvinculo = [];
      supervisoresTotal.map((ger, i) => {
        if (newDado.usuariosFilhos.find((user) => user == ger.id)) {
          newDado.supervisorescomvinculo.push(ger);
        } else {
          newDado.supervisoressemvinculo.push(ger);
        }
      });

      newDado.vendedorescomvinculo = [];
      newDado.vendedoressemvinculo = [];
      newDado.gerentesV = false;
      newDado.supervisoresV = true;
      newDado.vendedoresV = false;
    }

    newDado.departamento = e;

    setUserSelect({ ...newDado });
  }

  async function buscaCep() {
    var dados = userSelect.endereco.cep.trim();

    if (dados.replace("-", "").length < 8) {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Cep inválido, tente novamente.",
      });

      return;
    }

    try {
      var response = await Axios.get(
        "http://viacep.com.br/ws/" + dados + "/json/"
      );
    } catch (error) {
      console.log(error);
    }

    if (response.data.erro) {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: "Cep inválido, tente novamente.",
      });

      return;
    }

    var newuserend = userSelect;
    newuserend.endereco.rua = response.data.logradouro;
    newuserend.endereco.bairro = response.data.bairro;
    newuserend.endereco.cidade = response.data.localidade;
    newuserend.endereco.estado = response.data.uf;

    setUserSelect({ ...newuserend });
  }

  async function AttUser() {
    setLoading(true);

    var myHeaders = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache",
        Authorization: `bearer ${TOKEN}`,
      },
    };

    var Pais = [];
    var Filhos = [];

    if (userSelect.departamento === 10) {
      userSelect.supervisorescomvinculo.map((sup) => Pais.push(sup.id));
    } else {
      userSelect.gerentescomvinculo.map((ger) => Pais.push(ger.id));

      if (userSelect.departamento === 8) {
        userSelect.supervisorescomvinculo.map((vend) => Filhos.push(vend.id));
      } else {
        userSelect.vendedorescomvinculo.map((vend) => Filhos.push(vend.id));
      }
    }

    var Lojas = [];
    if (lojascomvinculo.length > 0) {
      lojascomvinculo.map((loj) => Lojas.push(loj.id));
    }

    var cpf = userSelect.codExt;

    if (cpf !== null && cpf !== "") {
      cpf = cpf.replace(".", "");
      cpf = cpf.replace(".", "");
      cpf = cpf.replace(".", "");
      cpf = cpf.replace("-", "");
    } else {
      cpf = "";
    }

    var dadosUser = {
      id: userSelect.id,
      departamento: userSelect.departamento,
      nome: userSelect.nome,
      codExt: cpf,
      login: userSelect.login,
      status: userSelect.statusId,
      pais: Pais,
      usuarios: Filhos,
      lojas: Lojas,
    };

    const retornoUser = await axios.post(
      `${URLBunge}/api/Vendedores/AddVendedor`,
      JSON.stringify(dadosUser),
      myHeaders
    );

    console.log("RESULT_AXIOS", retornoUser);

    if (retornoUser.status !== 200) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: retornoUser.data.mensagem,
      });

      return;
    }

    if (retornoUser.data.sucesso) {
      if (cpf && cpf !== "") {
        var celular = userSelect.celular;

        if (celular !== null && celular !== "") {
          celular = celular.replace("-", "");
        }

        var cep = userSelect.endereco.cep;

        var dadosCad = {
          idProjeto: 2329681,
          documento: cpf,
          nome: userSelect.nome,
          email: userSelect.login,
        };

        try {
          await axios.post(
            `${URLBunge}/api/AdminVendedor/CompletarCad`,
            JSON.stringify(dadosCad),
            myHeaders
          );
        } catch (erro) {
          // console.log('retornoCad', erro.response.data.mensagem)
          // setLoading(false);
          // Swal.fire({
          //   icon: 'warning',
          //   title: 'Ops!',
          //   text: erro.response.data.mensagem
          // });
          // return;
        }

        if (celular !== null && celular !== "") {
          var dadosTel = {
            idProjeto: 2329681,
            documento: cpf,
            tipo: 727,
            ddd: userSelect.ddd,
            numero: celular,
          };

          const retTel = await axios.post(
            `${URLBunge}/api/Cliente/AddTelefone`,
            JSON.stringify(dadosTel),
            myHeaders
          );

          if (retTel.status !== 200) {
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Ops!",
              text: retTel.data.mensagem,
            });
            return;
          }
        }

        if (cep !== null && cep !== undefined) {
          var dadosEnd = {
            idProjeto: 2329681,
            documento: cpf,
            tipo: 32,
            cep: userSelect.endereco.cep,
            Endereco: userSelect.endereco.rua,
            numero: userSelect.endereco.numero,
            complemento: userSelect.endereco.complemento,
            bairro: userSelect.endereco.bairro,
            cidade: userSelect.endereco.cidade,
            estado: userSelect.endereco.estado,
          };

          const retEnd = await axios.post(
            `${URLBunge}/Api/Cliente/AddEndereco`,
            JSON.stringify(dadosEnd),
            myHeaders
          );

          if (retEnd.status !== 200) {
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Ops!",
              text: retEnd.data.mensagem,
            });
            return;
          }
        }
      }

      Swal.fire({
        icon: "success",
        title: "Tudo Certo!",
        text: "Usuário inserido com sucesso!",
      }).then(async (result) => {
        window.location = "/VendedorUsers";
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Ops!",
        text: retornoUser.mensagem,
      });
    }

    setLoading(false);
  }

  async function AttUserExcel(userSelect, lojascomvinculo) {
    var Pais = [];
    var Filhos = [];
    if (userSelect.departamento == 10) {
      userSelect.supervisorescomvinculo.map((sup) => sup && Pais.push(sup.id));
    } else {
      userSelect.gerentescomvinculo.map((ger) => ger && Pais.push(ger.id));
      if (userSelect.departamento == 8) {
        userSelect.supervisorescomvinculo.map(
          (vend) => vend && Filhos.push(vend.id)
        );
      } else {
        userSelect.vendedorescomvinculo.map(
          (vend) => vend && Filhos.push(vend.id)
        );
      }
    }
    var Lojas = [];
    if (lojascomvinculo.length > 0) {
      lojascomvinculo.map((loj) => loj && Lojas.push(loj.id));
    }
    var dadosUser = {
      id: userSelect.id,
      departamento: userSelect.departamento,
      nome: userSelect.nome,
      codExt: userSelect.codExt,
      login: userSelect.login,
      status: userSelect.statusId,
      pais: Pais,
      usuarios: Filhos,
      lojas: Lojas,
    };
    // var retornoUser = await PostApi("Vendedores/AddVendedor",dadosUser);
  }

  function verificaLogin() {
    if (TOKEN === null) {
      history.push({ pathname: "/", state: {} });
      setLoading(false);
    }
  }

  useEffect(() => {
    // MUDA O TITULO DA PÁGINA
    document.title = "Plataforma Vendedor | Usuários";

    // LIBERA O SCROLL DA PÁGINA
    document.body.style.overflow = "auto";

    //AO CARREGAR A PÁGINA SCROLA PARA O TOPO
    window.scrollTo(0, 0);

    verificaLogin();

    return () => {
      // TRAVA O SCROLL AO SAIR DA PÁGINA
      document.body.style.overflow = "hidden";
    };
  }, []);

  return (
    <Container>
      <HeaderPortalVendedor />
      <MenuPrinc />

      {loading && <Carregando />}
      <HomeFornada>
        <div className="clear"></div>

        <div className="cadastros">
          <h1>Cadastro/Atualização Equipe</h1>

          <div id="filtros">
            <MDBBtn
              color="success"
              size="sm"
              onClick={() => toggle(5)}
              style={{ float: "right" }}
            >
              Cadastro via excel
            </MDBBtn>
            <MDBBtn
              color="unique"
              size="sm"
              onClick={() => arquivoexemplo()}
              style={{ float: "right" }}
            >
              Baixar arquivo exemplo
            </MDBBtn>
            <MDBBtn
              color="primary"
              size="sm"
              onClick={() => NovoUser()}
              style={{ float: "right" }}
            >
              Cadastro unitário
            </MDBBtn>
          </div>

          <div class="tabresp">
            <MDBDataTable
              striped
              bordered
              hover
              searchLabel="Pesquisar"
              paginationLabel={["Anterior", "Próximo"]}
              noRecordsFoundLabel="Nenhum resultado encontrado"
              infoLabel={["Mostrando", "de", "até", "registros"]}
              entriesLabel="Qtd por pagina"
              data={vendedores}
            />
          </div>
        </div>

        <MDBModal isOpen={modal4} toggle={() => toggle(4)} size="lg">
          <MDBModalHeader
            toggle={() => {
              toggle(4);
              setActiveItem("1");
            }}
          >
            Cadastro/Edição
          </MDBModalHeader>
          <MDBModalBody>
            <form className="oft">
              <MDBContainer>
                <MDBRow>
                  <MDBCol mb="6">
                    <select
                      className="browser-default custom-select"
                      onChange={(e) => alteraAbas(e.target.value)}
                    >
                      <option>Escolha o cargo</option>
                      <option
                        value={10}
                        selected={
                          userSelect?.departamento == 10 ? "selected" : ""
                        }
                      >
                        Vendedor
                      </option>
                      <option
                        value={9}
                        selected={
                          userSelect?.departamento == 9 ? "selected" : ""
                        }
                      >
                        Supervisor
                      </option>
                      <option
                        value={8}
                        selected={
                          userSelect?.departamento == 8 ? "selected" : ""
                        }
                      >
                        Gerente
                      </option>
                    </select>
                  </MDBCol>
                </MDBRow>

                {userSelect?.codExt === "" && userSelect.id !== 0 ? (
                  <MDBCol mb="12" style={{ marginTop: "10px" }}>
                    <MDBAlert color="danger">
                      <strong>Este Usuário não possui CPF.</strong> Não pode ser
                      editado o celular e endereço!
                    </MDBAlert>
                  </MDBCol>
                ) : (
                  ""
                )}

                <MDBNav className="nav-tabs mt-5">
                  <MDBNavItem>
                    <MDBNavLink
                      link
                      to="#"
                      active={activeItem === "1"}
                      onClick={() => toggletab("1")}
                      role="tab"
                    >
                      Dados do Usuário
                    </MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink
                      link
                      to="#"
                      active={activeItem === "2"}
                      onClick={() => toggletab("2")}
                      role="tab"
                    >
                      Endereço
                    </MDBNavLink>
                  </MDBNavItem>
                  {/* <MDBNavItem>
                    <MDBNavLink link to="#" active={activeItem === "3"} onClick={() => toggletab("3")} role="tab" >
                      Lojas
                    </MDBNavLink>
                  </MDBNavItem> */}
                  {userSelect?.vendedoresV && (
                    <MDBNavItem>
                      <MDBNavLink
                        link
                        to="#"
                        active={activeItem === "4"}
                        onClick={() => toggletab("4")}
                        role="tab"
                      >
                        Vendedores
                      </MDBNavLink>
                    </MDBNavItem>
                  )}
                  {/* {
                  userSelect?.supervisoresV &&
                  <MDBNavItem>
                    <MDBNavLink link to="#" active={activeItem === "5"} onClick={() => toggletab("5")} role="tab" >
                      Supervisores
                    </MDBNavLink>
                  </MDBNavItem>
                } */}
                  {/* {
                  userSelect?.gerentesV &&
                  <MDBNavItem>
                    <MDBNavLink link to="#" active={activeItem === "6"} onClick={() => toggletab("6")} role="tab" >
                      Gerentes
                    </MDBNavLink>
                  </MDBNavItem>
                } */}
                </MDBNav>

                <MDBTabContent activeItem={activeItem}>
                  <MDBTabPane tabId="1" role="tabpanel">
                    <MDBRow>
                      <MDBCol lg="12">
                        <MDBInput
                          label="Nome"
                          outline
                          size="lg"
                          value={userSelect.nome}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.nome = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                        />
                      </MDBCol>

                      <MDBCol lg="6">
                        <MDBInput
                          label="Login"
                          outline
                          size="lg"
                          value={userSelect.login}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.login = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                        />
                      </MDBCol>

                      <MDBCol mb="6">
                        <InputMask
                          placeholder="CPF"
                          type="text"
                          alt="#"
                          autoComplete="off"
                          className="number"
                          value={userSelect.codExt}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.codExt = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          mask="999.999.999-99"
                          maskChar={null}
                          readOnly={disabled}
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol lg="2">
                        <InputMask
                          placeholder="DDD"
                          type="text"
                          label="DDD"
                          outline
                          alt="#"
                          autoComplete="off"
                          className="number"
                          mask="99"
                          value={userSelect.ddd}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.ddd = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <InputMask
                          placeholder="Celular"
                          type="text"
                          autoComplete="off"
                          outline
                          className="number"
                          mask="99999-9999"
                          value={userSelect.celular}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.celular = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>

                      <MDBCol mb="4">
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.statusId = parseInt(e.target.value);
                            setUserSelect({ ...newDado });
                          }}
                        >
                          <option value="">Status</option>
                          <option
                            value={1}
                            selected={
                              userSelect.statusId == 1 ? "selected" : ""
                            }
                          >
                            ATIVO
                          </option>
                          <option
                            value={2}
                            selected={
                              userSelect.statusId == 2 ? "selected" : ""
                            }
                          >
                            BLOQUEADA
                          </option>
                        </select>
                        {/*     <MDBInput label="status" outline size="lg" value={userSelect.statusId} /> */}
                      </MDBCol>
                    </MDBRow>
                  </MDBTabPane>

                  <MDBTabPane tabId="2" role="tabpanel">
                    <MDBRow>
                      <MDBCol lg="4">
                        <InputMask
                          placeholder="CEP"
                          type="text"
                          autoComplete="off"
                          outline
                          className="number"
                          mask="99999-999"
                          value={userSelect.endereco.cep}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.cep = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                          maskChar=""
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <MDBBtn
                          color="primary"
                          size="sm"
                          onClick={() => buscaCep()}
                          style={{ float: "right" }}
                        >
                          Pesquisar
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <MDBCol lg="6">
                        <MDBInput
                          label="Rua"
                          outline
                          size="lg"
                          value={userSelect.endereco.rua}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.rua = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="2">
                        <MDBInput
                          label="nº"
                          outline
                          size="lg"
                          value={userSelect.endereco.numero}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.numero = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <MDBInput
                          label="Complemento"
                          outline
                          size="lg"
                          value={userSelect.endereco.complemento}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.complemento = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <MDBInput
                          label="Bairro"
                          outline
                          size="lg"
                          value={userSelect.endereco.bairro}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.bairro = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <MDBInput
                          label="Cidade"
                          outline
                          size="lg"
                          value={userSelect.endereco.cidade}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.cidade = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                      <MDBCol lg="4">
                        <MDBInput
                          label="Estado"
                          outline
                          size="lg"
                          value={userSelect.endereco.estado}
                          onChange={(e) => {
                            var newDado = userSelect;
                            newDado.endereco.estado = e.target.value;
                            setUserSelect({ ...newDado });
                          }}
                          readOnly={block}
                        />
                      </MDBCol>
                    </MDBRow>
                  </MDBTabPane>

                  <MDBTabPane tabId="3" role="tabpanel" className="tabelas">
                    <MDBRow>
                      <MDBCol lg="12">
                        <MDBInput
                          label="Filtre por CNPJ(acima de 3 caracteres)"
                          outline
                          size="lg"
                          value={pesquisaLoja}
                          onChange={(e) => setPesquisaLoja(e.target.value)}
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow>
                      <section>
                        <h2> Lojas sem vinculo</h2>
                        <div>
                          <MDBTable>
                            <MDBTableHead>
                              <tr>
                                <th>CNPJ/Razão Social</th>
                                <th>Vincular</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {pesquisaLoja.length > 2 &&
                                lojassemvinculo.map((loj, i) => {
                                  var cnpjNome = loj.cnpj + " - " + loj.nome;
                                  if (cnpjNome.indexOf(pesquisaLoja) < 0) {
                                    return;
                                  }
                                  return (
                                    <tr key={i}>
                                      <td>{cnpjNome}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          value=""
                                          checked={false}
                                          onClick={() => {
                                            var novoSemVinculo =
                                              lojassemvinculo;
                                            var novoComVinculo =
                                              lojascomvinculo;

                                            novoSemVinculo.splice(i, 1);
                                            novoComVinculo.push(loj);

                                            // setState({
                                            // lojassemvinculo:novoSemVinculo,
                                            // lojascomvinculo:novoComVinculo
                                            // });

                                            setLojascomvinculo([
                                              ...novoComVinculo,
                                            ]);
                                            setLojassemvinculo([
                                              ...novoSemVinculo,
                                            ]);
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      </section>

                      <section>
                        <h2> Lojas com vinculo</h2>
                        <div>
                          <MDBTable>
                            <MDBTableHead>
                              <tr>
                                <th>CNPJ</th>
                                <th>Desvincular</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {lojascomvinculo.length > 0 &&
                                lojascomvinculo.map((loj, i) => {
                                  var cnpjNome = loj.cnpj + " - " + loj.nome;
                                  if (cnpjNome.indexOf(pesquisaLoja) < 0) {
                                    return;
                                  }
                                  return (
                                    <tr key={i}>
                                      <td>{cnpjNome}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          value=""
                                          checked={true}
                                          onClick={() => {
                                            var novoSemVinculo =
                                              lojassemvinculo;
                                            var novoComVinculo =
                                              lojascomvinculo;

                                            novoComVinculo.splice(i, 1);
                                            novoSemVinculo.push(loj);

                                            // setState({
                                            // lojassemvinculo:novoSemVinculo,
                                            // lojascomvinculo:novoComVinculo
                                            // });

                                            setLojascomvinculo([
                                              ...novoComVinculo,
                                            ]);
                                            setLojassemvinculo([
                                              ...novoSemVinculo,
                                            ]);
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      </section>
                    </MDBRow>

                    <div className="clear"></div>
                  </MDBTabPane>

                  <MDBTabPane tabId="4" role="tabpanel" className="tabelas">
                    <MDBRow>
                      <MDBCol lg="12">
                        <MDBInput
                          label="Filtre por CPF ou Login"
                          outline
                          size="lg"
                          value={pesquisaVendedor}
                          onChange={(e) => setPesquisaVendedor(e.target.value)}
                        />
                      </MDBCol>
                    </MDBRow>

                    <section>
                      <h2> Vendedores sem vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Vincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.vendedoressemvinculo.length > 0 &&
                              userSelect.vendedoressemvinculo.map((vend, i) => {
                                var codExtNome =
                                  vend.codExt != null
                                    ? vend.codExt
                                    : "" + " - " + vend.nome;
                                if (
                                  codExtNome
                                    .toUpperCase()
                                    .indexOf(pesquisaVendedor.toUpperCase()) < 0
                                ) {
                                  return;
                                }
                                return (
                                  <tr key={i}>
                                    <td>{codExtNome}</td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        value=""
                                        checked={false}
                                        onClick={() => {
                                          var novoDado = userSelect;
                                          novoDado.vendedoressemvinculo.splice(
                                            i,
                                            1
                                          );
                                          novoDado.vendedorescomvinculo.push(
                                            vend
                                          );
                                          setUserSelect({ ...novoDado });
                                          // setState({userSelect:novoDado})
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <section>
                      <h2> Vendedores com vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Desvincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.vendedorescomvinculo.length > 0 &&
                              userSelect.vendedorescomvinculo.map((vend, i) => {
                                var codExtNome =
                                  vend.codExt != null
                                    ? vend.codExt
                                    : "" + " - " + vend.nome;
                                if (
                                  codExtNome
                                    .toUpperCase()
                                    .indexOf(pesquisaVendedor.toUpperCase()) < 0
                                ) {
                                  return;
                                }
                                return (
                                  <tr key={i}>
                                    <td>{codExtNome}</td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        value=""
                                        checked={true}
                                        onClick={() => {
                                          var novoDado = userSelect;
                                          novoDado.vendedorescomvinculo.splice(
                                            i,
                                            1
                                          );
                                          novoDado.vendedoressemvinculo.push(
                                            vend
                                          );
                                          // setState({userSelect:novoDado})
                                          setUserSelect({ ...novoDado });
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <div className="clear"></div>
                  </MDBTabPane>

                  <MDBTabPane tabId="5" role="tabpanel" className="tabelas">
                    <MDBRow>
                      <MDBCol lg="12">
                        <MDBInput
                          label="Filtre por CPF ou Login"
                          outline
                          size="lg"
                          value={pesquisaSupervisor}
                          onChange={(e) =>
                            setPesquisaSupervisor(e.target.value)
                          }
                        />
                      </MDBCol>
                    </MDBRow>

                    <section>
                      <h2> Supervisores sem vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Vincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.supervisoressemvinculo.length > 0 &&
                              userSelect.supervisoressemvinculo.map(
                                (sup, i) => {
                                  var codExtNome =
                                    sup.codExt != null
                                      ? sup.codExt
                                      : "" + " - " + sup.nome;
                                  if (
                                    codExtNome
                                      .toUpperCase()
                                      .indexOf(
                                        pesquisaSupervisor.toUpperCase()
                                      ) < 0
                                  ) {
                                    return;
                                  }
                                  return (
                                    <tr key={i}>
                                      <td>{codExtNome}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          value=""
                                          checked={false}
                                          onClick={() => {
                                            var novoDado = userSelect;
                                            novoDado.supervisoressemvinculo.splice(
                                              i,
                                              1
                                            );
                                            novoDado.supervisorescomvinculo.push(
                                              sup
                                            );
                                            // setState({userSelect:novoDado})
                                            setUserSelect({ ...novoDado });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <section>
                      <h2> Supervisores com vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Desvincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.supervisorescomvinculo.length > 0 &&
                              userSelect.supervisorescomvinculo.map(
                                (sup, i) => {
                                  var codExtNome =
                                    sup.codExt != null
                                      ? sup.codExt
                                      : "" + " - " + sup.nome;
                                  if (
                                    codExtNome
                                      .toUpperCase()
                                      .indexOf(
                                        pesquisaSupervisor.toUpperCase()
                                      ) < 0
                                  ) {
                                    return;
                                  }
                                  return (
                                    <tr key={i}>
                                      <td>{codExtNome}</td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          value=""
                                          checked={true}
                                          onClick={() => {
                                            var novoDado = userSelect;
                                            novoDado.supervisorescomvinculo.splice(
                                              i,
                                              1
                                            );
                                            novoDado.supervisoressemvinculo.push(
                                              sup
                                            );
                                            // setState({userSelect:novoDado})
                                            setUserSelect({ ...novoDado });
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <div className="clear"></div>
                  </MDBTabPane>

                  <MDBTabPane tabId="6" role="tabpanel" className="tabelas">
                    <MDBRow>
                      <MDBCol lg="12">
                        <MDBInput
                          label="Filtre por CPF ou Login"
                          outline
                          size="lg"
                          value={pesquisaGerente}
                          onChange={(e) => setPesquisaGerente(e.target.value)}
                        />
                      </MDBCol>
                    </MDBRow>

                    <section>
                      <h2> Gerentes sem vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Vincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.gerentessemvinculo.map((ger, i) => {
                              var codExtNome =
                                ger.codExt != null
                                  ? ger.codExt
                                  : "" + " - " + ger.nome;
                              if (
                                codExtNome
                                  .toUpperCase()
                                  .indexOf(pesquisaGerente.toUpperCase()) < 0
                              ) {
                                return;
                              }
                              return (
                                <tr key={i}>
                                  <td>{codExtNome}</td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      value=""
                                      checked={false}
                                      onClick={() => {
                                        var novoDado = userSelect;
                                        novoDado.gerentessemvinculo.splice(
                                          i,
                                          1
                                        );
                                        novoDado.gerentescomvinculo.push(ger);
                                        // setState({userSelect:novoDado})
                                        setUserSelect({ ...novoDado });
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <section>
                      <h2> Gerentes com vinculo</h2>
                      <div>
                        <MDBTable>
                          <MDBTableHead>
                            <tr>
                              <th>CPF/login</th>
                              <th>Desvincular</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {userSelect.gerentescomvinculo.map((ger, i) => {
                              var codExtNome =
                                ger.codExt != null
                                  ? ger.codExt + " - " + ger.nome
                                  : ger.nome;
                              if (
                                codExtNome
                                  .toUpperCase()
                                  .indexOf(pesquisaGerente.toUpperCase()) < 0
                              ) {
                                return;
                              }
                              return (
                                <tr key={i}>
                                  <td>{codExtNome}</td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      value=""
                                      checked={true}
                                      onClick={() => {
                                        var novoDado = userSelect;
                                        novoDado.gerentescomvinculo.splice(
                                          i,
                                          1
                                        );
                                        novoDado.gerentessemvinculo.push(ger);
                                        // setState({userSelect:novoDado})
                                        setUserSelect({ ...novoDado });
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    </section>

                    <div className="clear"></div>
                  </MDBTabPane>
                </MDBTabContent>
              </MDBContainer>
            </form>
          </MDBModalBody>
          <MDBModalFooter>
            {userSelect.id != null ? (
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => AttUser("Atualizar")}
              >
                Atualizar
              </MDBBtn>
            ) : (
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => AttUser("Cadastrar")}
              >
                Cadastrar
              </MDBBtn>
            )}
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={modal5} toggle={() => toggle(5)} size="md">
          <MDBModalHeader toggle={() => toggle(5)}>
            Cadastro via Excel
          </MDBModalHeader>
          <MDBModalBody>
            <form className="oft" id="ArquivoInput">
              <MDBRow>
                <MDBCol md="12">
                  <MDBCol md="12" style={{ float: "left" }}>
                    <label>Upload do Mailing</label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          id="inputGroupFileAddon01"
                        >
                          Upload
                        </span>
                      </div>
                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="ImagemFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="xls/*"
                          onChange={(e) => {
                            MudaVisibilidade("UpLoading");
                            LeArquivo(e);
                          }}
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="ImagemFile"
                        >
                          Arquivo do Excel
                          <img
                            src={carregando}
                            id="UpLoading"
                            style={{
                              width: "15%",
                              "margin-top": "-10px",
                              "margin-right": "150px",
                              display: "none",
                              float: "right",
                            }}
                          />
                        </label>
                      </div>
                    </div>
                    <small> Extensão .xlsx</small>
                  </MDBCol>
                </MDBCol>
              </MDBRow>
            </form>

            <form
              className="oft"
              id="ArquivoCadastrar"
              style={{ display: "none" }}
            >
              <MDBRow>
                <MDBCol md="12">
                  <MDBCol md="12" style={{ float: "left" }}>
                    <h3
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        MudaVisibilidade("ArquivoInput");
                        MudaVisibilidade("ArquivoCadastrar");
                      }}
                    >
                      {"< Voltar"}
                    </h3>
                    <h1>Foram Encontrados:</h1>
                    <label>{dadosUparGerentes.length} Gerente(s)</label>
                    <img
                      src={CarregarGer ? carregando : Certo}
                      id="GerenteUp"
                      style={{
                        width: "8%",
                        "margin-top": "-10px",
                        "margin-right": "265px",
                        display: "none",
                        float: "right",
                      }}
                    />
                    <br />
                    <label>{dadosUparSupervisores.length} Supervisor(es)</label>
                    <img
                      src={CarregarSup ? carregando : Certo}
                      id="SupervisorUp"
                      style={{
                        width: "8%",
                        "margin-top": "-10px",
                        "margin-right": "265px",
                        display: "none",
                        float: "right",
                      }}
                    />
                    <br />
                    <label>{dadosUparVendedores.length} Vendedor(es)</label>
                    <img
                      src={CarregarVend ? carregando : Certo}
                      id="VendedorUp"
                      style={{
                        width: "8%",
                        "margin-top": "-10px",
                        "margin-right": "265px",
                        display: "none",
                        float: "right",
                      }}
                    />
                    <br />
                    <MDBBtn
                      color="primary"
                      size="sm"
                      onClick={() => CadastrarExcel()}
                    >
                      Concluir Cadastro
                    </MDBBtn>
                  </MDBCol>
                </MDBCol>
              </MDBRow>
            </form>
          </MDBModalBody>
        </MDBModal>
      </HomeFornada>
    </Container>
  );
}

export default VendedorUsers;
